import { motion } from "framer-motion";
import { IMAGES } from "@/data/menuData";
import { ImageLightbox } from "@/components/ImageLightbox";

export const HeroSection = () => {
  return (
    <section data-testid="hero-section" className="relative bg-[#2B3618] overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'60\' height=\'60\' viewBox=\'0 0 60 60\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.4\'%3E%3Cpath d=\'M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z\'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")',
        }} />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-center">
          {/* Logo Column */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="md:col-span-4 flex flex-col items-center md:items-start"
          >
            <img
              src={IMAGES.logo}
              alt="Adrianoz Pizza Logo"
              className="w-48 sm:w-56 md:w-72 lg:w-80 drop-shadow-2xl rounded-full"
              data-testid="hero-logo"
            />
            <motion.p
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.8 }}
              className="mt-4 md:mt-6 font-['Playfair_Display'] text-[#F5F5F5] text-lg md:text-xl lg:text-2xl text-center md:text-left leading-relaxed"
            >
              El mismo amor por la pizza,<br />
              <span className="text-[#C41E3A] font-bold">ahora más grande.</span>
            </motion.p>
            <motion.a
              href="https://wa.me/525522282990"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-whatsapp-btn"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: 0.8, duration: 0.5 }}
              whileHover={{ scale: 1.05, y: -2 }}
              whileTap={{ scale: 0.97 }}
              className="mt-6 inline-flex items-center gap-3 bg-[#C41E3A] hover:bg-[#9A172D] text-white font-['DM_Sans'] font-bold px-8 py-4 rounded-full shadow-lg shadow-[#C41E3A]/30 transition-colors duration-300"
            >
              <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              Pedir por WhatsApp
            </motion.a>
          </motion.div>

          {/* Bento Grid */}
          <div className="md:col-span-8 grid grid-cols-2 gap-3 md:gap-4">
            <ImageLightbox src={IMAGES.pizzaCuadrada} alt="Maxi Pizza">
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.2 }}
                className="col-span-2 relative h-[220px] sm:h-[280px] md:h-[320px] rounded-2xl overflow-hidden group cursor-pointer"
              >
                <img
                  src={IMAGES.pizzaCuadrada}
                  alt="Maxi Pizza"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-4 md:p-6">
                  <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C41E3A] font-['DM_Sans']">Especialidad</span>
                  <h3 className="text-white font-['Playfair_Display'] text-xl md:text-2xl font-bold mt-1">Maxi Pizza</h3>
                  <p className="text-white/70 text-sm font-['DM_Sans'] mt-1">$589</p>
                </div>
              </motion.div>
            </ImageLightbox>

            <ImageLightbox src={IMAGES.pizzaHawaiiana} alt="Pizza Hawaiana">
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.4 }}
                className="relative h-[180px] sm:h-[220px] md:h-[260px] rounded-2xl overflow-hidden group cursor-pointer"
              >
                <img
                  src={IMAGES.pizzaHawaiiana}
                  alt="Pizza Hawaiana"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-4">
                  <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C41E3A] font-['DM_Sans']">Clásica</span>
                  <h3 className="text-white font-['Playfair_Display'] text-lg md:text-xl font-bold mt-1">Hawaiana</h3>
                </div>
              </motion.div>
            </ImageLightbox>

            <ImageLightbox src={IMAGES.lasagna} alt="Lasaña Boloñesa">
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.5 }}
                className="relative h-[180px] sm:h-[220px] md:h-[260px] rounded-2xl overflow-hidden group cursor-pointer"
              >
                <img
                  src={IMAGES.lasagna}
                  alt="Lasaña Boloñesa"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-4">
                  <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C41E3A] font-['DM_Sans']">Pastas</span>
                  <h3 className="text-white font-['Playfair_Display'] text-lg md:text-xl font-bold mt-1">Lasaña Boloñesa</h3>
                </div>
              </motion.div>
            </ImageLightbox>

            <ImageLightbox
              src="/photos/3cd9taq9_IMG_0890.jpg"
              alt="Hamburguesa Hawaiian"
            >
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: 0.6 }}
                className="col-span-2 relative h-[180px] sm:h-[220px] md:h-[260px] rounded-2xl overflow-hidden group cursor-pointer"
              >
                <img
                  src="/photos/3cd9taq9_IMG_0890.jpg"
                  alt="Hamburguesa Hawaiian"
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
                <div className="absolute bottom-0 left-0 p-4">
                  <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#C41E3A] font-['DM_Sans']">Hamburguesas</span>
                  <h3 className="text-white font-['Playfair_Display'] text-lg md:text-xl font-bold mt-1">Hamburguesa Hawaiian</h3>
                </div>
              </motion.div>
            </ImageLightbox>
          </div>
        </div>
      </div>
    </section>
  );
};
